import React from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql, Link } from 'gatsby';

import './footer.scss';
import { Container, Row, Col } from 'react-bootstrap';

const Footer = (props) => {
  const data = useStaticQuery(graphql`
    query {
      allMenuFooter {
        nodes {
          title
          relative
        }
      }
      logoSVG: file(relativePath: { eq: "logo.svg" }) {
        publicURL
      }
      msSVG: file(relativePath: { eq: "ms-gold-partner-logo.svg" }) {
        publicURL
      }
      atturaLogo: file(
        relativePath: { eq: "atturra-logo-white.png" }
      ) {
        publicURL
      }
      linkedin: file(relativePath: { eq: "social-linkedin.svg" }) {
        publicURL
      }
      facebook: file(relativePath: { eq: "social-facebook.svg" }) {
        publicURL
      }
      twitter: file(relativePath: { eq: "social-twitter.svg" }) {
        publicURL
      }
    }
  `);

  return (
    <footer
      className={'c-footer'}
      style={{
        boxShadow: '0px -5px 5px rgba(0,0,0,0.25)',
        position: 'relative',
        zIndex: 9997,
      }}
    >
      <section style={{ paddingTop: '30px' }}>
        <Container>
          <Row className="justify-content-center">
            <div className="d-flex">
              <img
                src={data.logoSVG.publicURL}
                alt={'Veritec Logo'}
                style={{ height: '80px', margin: '30px 25px' }}
              />
            </div>
            <div className="d-flex">
              <img
                src={data.msSVG.publicURL}
                alt={'Microsoft Gold Partner'}
                style={{ height: '80px', margin: '30px 25px' }}
              />
            </div>
          </Row>
        </Container>

        <Container>
          <Row className={'justify-content-center text-center'}>
            <Col xs={12}>
              <Row className="justify-content-start">
                {data.allMenuFooter &&
                  data.allMenuFooter.nodes.map((edge, index) => {
                    // console.log(edge.node)
                    return (
                      <Col
                        xs={6}
                        md={4}
                        style={{ margin: '10px 0' }}
                        key={index}
                      >
                        <Link to={edge.relative}>{edge.title}</Link>
                      </Col>
                    );
                  })}
              </Row>
            </Col>
          </Row>
        </Container>

        <Container>
          <hr />
        </Container>

        <Container style={{ paddingBottom: '15px' }}>
          <Row className={'justify-content-center'}>
            <Col xs={12} md={4} className="m-auto text-left">
              <h5>Our contact info</h5>
            </Col>
            <Col xs={12} md={4} className="text-center">
              <p>
                <a href="mailto:info@veritec.com.au">
                  info@veritec.com.au
                </a>
              </p>
              <p>
                <a href="tel:1300393449">Phone: 1300 393 449</a>
              </p>
              <p>
                <a href="tel:+61262258133">Fax: +61 (02) 6225 8133</a>
              </p>
            </Col>
            <Col xs={12} md={4} className="m-auto">
              <Row className={'justify-content-end'}>
                <a
                  href="https://au.linkedin.com/company/veritec"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <img
                    src={data.linkedin.publicURL}
                    alt={'Linked-in'}
                    style={{ height: '50px', margin: '10px' }}
                  />
                </a>
                <a
                  href="https://www.facebook.com/veritecaus"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <img
                    src={data.facebook.publicURL}
                    alt={'Facebook'}
                    style={{ height: '50px', margin: '10px' }}
                  />
                </a>
                <a
                  href="https://twitter.com/veritecaus"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <img
                    src={data.twitter.publicURL}
                    alt={'Twitter'}
                    style={{ height: '50px', margin: '10px' }}
                  />
                </a>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>

      <section
        className={'section dark'}
        style={{
          position: 'relative',
          paddingTop: '10px',
          paddingBottom: '10px',
        }}
      >
        <div
          style={{
            backgroundColor: '#17285a',
            position: 'absolute',
            top: '0px',
            left: '0px',
            width: '100%',
            height: '100%',
          }}
        ></div>
        <Container fluid={true}>
          <Row className={'justify-content-between'}>
            <Col
              xs={8}
              className={'d-flex text-left'}
              style={{ paddingTop: 0, paddingBottom: 0 }}
            >
              <p
                className={'mt-auto mb-auto'}
                style={{ fontSize: '1rem' }}
              >
                <span className={'col'} style={{ paddingleft: 0 }}>
                  <a
                    href="/sitemap.xml"
                    style={{
                      color: '#ffffff',
                      textDecoration: 'underline',
                    }}
                  >
                    Sitemap
                  </a>
                </span>
                <span className={'col'}>
                  <a
                    href="/privacy-policy"
                    style={{
                      color: '#ffffff',
                      textDecoration: 'underline',
                    }}
                  >
                    Privacy policy
                  </a>
                </span>
                <span className={'col'}>
                  <a
                    href="/terms-use"
                    style={{
                      color: '#ffffff',
                      textDecoration: 'underline',
                    }}
                  >
                    Terms of use
                  </a>
                </span>
                <span className={'col'} style={{ paddingRight: 0 }}>
                  © {props.siteTitle} {new Date().getFullYear()}
                </span>
              </p>
            </Col>
            <Col
              xs={4}
              className={'d-flex justify-content-end'}
              style={{ paddingTop: 0, paddingBottom: 0 }}
            >
              <a
                href="https://atturra.com/au-en/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  alt={'Atturra Logo'}
                  src={data.atturaLogo.publicURL}
                  style={{ height: '25px' }}
                />
              </a>
               
            </Col>
          </Row>
        </Container>
      </section>
    </footer>
  );
};

Footer.propTypes = {
  siteTitle: PropTypes.string,
};

Footer.defaultProps = {
  siteTitle: ``,
};

export default Footer;
